/**
 * FormCondition
 * ======================================
 * - show / hide field depending on other value
 * - work on selects only
 */

const CUSTOMIZER = '.js-Customizer'
const WIDGET = '[data-FormCondition]'

class FormCondition {
  constructor() {
    this.customizer = document.querySelector(CUSTOMIZER)
    this.conditionsElements = document.querySelectorAll(WIDGET)
    this.conditionsSelectElements = document.querySelectorAll('select[data-FormConditionSelect]')
    this.conditionsRadioElements = document.querySelectorAll('.customizer__item-radios[data-FormConditionRadio]')

    if(!this.customizer){
      return
    }

    this.customizer.addEventListener('change', this.changeFormHandler)
  }

  triggerChange = () => {
    var event = new Event('change')
    this.customizer.dispatchEvent(event)
  }

  getTargetValue = (fieldName) => {
    var field = document.querySelector('[name='+fieldName+']')

    if(field.getAttribute('type') == 'radio'){
      var field = document.querySelector('input[name='+fieldName+']:checked')
    }

    return field.value
  }

  updateFieldStatus = (field, status) => {
    // select (option)
    if(field.closest('select')){
      field.setAttribute('disabled', 'disabled')
      field.setAttribute('hidden', 'hidden')

      if(status) {
        field.removeAttribute('hidden')
        field.removeAttribute('disabled')
      }
    }

    // groups or basic fields
    if (field.closest('.control-group-pickups') || field.closest('.customizer__item[data-formcondition]')) {
      field.setAttribute('hidden', 'hidden')

      if(status) {
        field.removeAttribute('hidden')
      }
    }
  }

  changeFormHandler = () => {
    this.conditionsElements.forEach((field) => {
      const json = JSON.parse(field.dataset.json)
      const conditions = json.fields
      var conditionIsValid = true

      conditions.forEach((condition) => {
        const conditionTargetValue = this.getTargetValue(condition.field)

        if(!condition.values.includes(conditionTargetValue)) {
          conditionIsValid = false
        }
      })

      this.updateFieldStatus(field, conditionIsValid)
    })

    // set the first valid option in select
    this.conditionsSelectElements.forEach((select) => {
      const newValueIsHidden = select.querySelector("option[value='"+select.value+"']").getAttribute('hidden')

      if(newValueIsHidden){
        if(!select.querySelector('option:not([hidden])')) {
          console.log('FormCondition: Element v podmínce neexistuje nebo chybí', select)

          return false
        }

        select.value = select.querySelector('option:not([hidden])').value

        this.triggerChange()
      }
    })

    // set the first valid option in radio input
    this.conditionsRadioElements.forEach((radioGroup) => {
      const newValueIsHidden = radioGroup.querySelector('input:checked').closest('.customizer__item-radio').getAttribute('hidden')

      if(newValueIsHidden){
        radioGroup.querySelector('.customizer__item-radio[hidden]').querySelector('input').removeAttribute('checked')
        radioGroup.querySelector('.customizer__item-radio:not([hidden])').querySelector('input').setAttribute('checked', 'checked')

        this.triggerChange()
      }
    })

  }
}

new FormCondition()
